<template>
	<div class="tpl my-page-wrap">
		<div class="page-title-bar">
			<p class="user-name">{{baseInfo.nickname}}</p>
			<p class="user-info">{{baseInfo.age}}岁 | {{baseInfo.height}}CM | {{baseInfo.education}} | {{baseInfo.annual_income}}</p>
			<router-link tag="span" :to="{name:'mine'}" class="back">
				<img src="../../assets/img/chats/ic_nav_back_pressed@2x.png" alt="" />
			</router-link>
		</div>
		<div class="user-intro">
			<div class="user-img">
				<div class="user-avatar">
					<img :src="baseInfo.avatar" />
					<input type="file" @change="changeAvatar" accept="image/*" ref="changeavatar"/>
				</div>
				<span class="level" v-if="baseInfo.is_vip">
					<img src="../../assets/img/mine/center_ic_head_pressed1.png" alt="" />
					<span class="num">{{baseInfo.grade}}</span>
				</span>
				<span class="sex">
					<img v-if="baseInfo.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
					<img v-if="baseInfo.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
				</span>
			</div>
			<p class="user-name">{{baseInfo.nickname}}<img v-if="baseInfo.is_vip" src="../../assets/img/common/ic_user_vip@2x.png" alt="" /></p>
			<p class="user-info">ID:{{baseInfo.uid}} | {{baseInfo.city}}</p>
		</div>
		<div class="user-show">
			<ul>
				<li v-for="item in baseInfo.attach" v-if="baseInfo.attach">
					<img :src="item" alt="" />
				</li>
				<li>
					<img src="../../assets/img/default/yushuiyuan.png" alt="" />
				</li>
				<li @click="toAppDo">
					<img src="../../assets/img/finds/ic_btn_add@2x.png"/>
				</li>
			</ul>
		</div>
		<div class="user-content">
			<mt-navbar v-model="selected">
				<mt-tab-item id="1">资料信息</mt-tab-item>
				<mt-tab-item id="2">动态</mt-tab-item>
				<mt-tab-item id="3">树洞</mt-tab-item>
			</mt-navbar>

			<!-- tab-container -->
			<mt-tab-container v-model="selected">
				<mt-tab-container-item id="1" class="personal-info">
					<div class="item-wrap">
						<p class="item-title">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								交友宣言
							</span>
							<span class="option" @click="showMendSign=1">
								修改宣言
								<img src="../../assets/img/common/ic_arrow_enter@2x.png"/>
							</span>
						</p>
						<div class="sign-text">
							{{baseInfo.sig}}
						</div>
					</div>
					<div class="item-wrap">
						<p class="item-title">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								已认证
							</span>
							<router-link tag="span" :to="{name:'my-certification'}" class="option">
								继续认证
								<img src="../../assets/img/common/ic_arrow_enter@2x.png"/>
							</router-link>
						</p>
						<div class="certi-list">
							<ul>
								<li v-if="baseInfo.is_real"><img src="../../assets/img/mine/center_center_4.png" alt="" /><p>实名认证</p></li>
								<li v-if="baseInfo.is_house"><img src="../../assets/img/mine/center_center_5.png" alt="" /><p>房产认证</p></li>
								<li v-if="baseInfo.is_education"><img src="../../assets/img/mine/center_center_6.png" alt="" /><p>学历认证</p></li>
								<li v-if="baseInfo.is_vehicle"><img src="../../assets/img/mine/center_center_7.png" alt="" /><p>车辆认证</p></li>
							</ul>
							
						</div>
					</div>
					<div class="item-wrap">
						<p class="item-title">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								基本资料
							</span>
							<router-link tag="span" :to="{name:'edit-personal-info'}" class="option">
								编辑个人资料
								<img src="../../assets/img/common/ic_arrow_enter@2x.png"/>
							</router-link>
						</p>
						<div class="baseinfo">
							<ul>
								<li><span class="name">ID</span><span class="value">{{baseInfo.uid}}</span></li>
								<li><span class="name">年龄</span><span class="value">{{baseInfo.age}}岁</span></li>
								<li><span class="name">身高</span><span class="value">{{baseInfo.height}}CM</span></li>
								<li><span class="name">昵称</span><span class="value">{{baseInfo.nickname}}</span></li>
								<li><span class="name">性别</span><span class="value">{{baseInfo.gender?"男":"女"}}</span></li>
								<li><span class="name">生日</span><span class="value">{{baseInfo.birthday}}</span></li>
								<li><span class="name">学历</span><span class="value">{{baseInfo.education|educationFormat}}</span></li>
								<li><span class="name">年收入</span><span class="value">{{baseInfo.annual_income}}</span></li>
								<li><span class="name">所在地</span><span class="value">{{baseInfo.city}}</span></li>
							</ul>
						</div>
					</div>
					<div class="item-wrap">
						<p class="item-title">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								高级资料
							</span>
							<router-link tag="span" :to="{name:'edit-personal-info'}" class="option">
								立即完善高级资料
								<img src="../../assets/img/common/ic_arrow_enter@2x.png"/>
							</router-link>
						</p>
						<div class="baseinfo">
							<ul>
								<li><span class="name">购房情况</span><span class="value">{{baseInfo.buy_house}}</span></li>
								<li><span class="name">购车情况</span><span class="value">{{baseInfo.car_buying}}</span></li>
								<li><span class="name">婚姻</span><span class="value">{{baseInfo.marriage}}</span></li>
								<li><span class="name">宗教</span><span class="value">{{baseInfo.religion}}</span></li>
								<li><span class="name">子女</span><span class="value">{{baseInfo.children}}</span></li>
							</ul>
						</div>
					</div>
					<div class="item-wrap">
						<p class="item-title">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								择偶标准
							</span>
							<router-link tag="span" :to="{name:'edit-personal-info'}" class="option">
								修改择偶标准
								<img src="../../assets/img/common/ic_arrow_enter@2x.png"/>
							</router-link>
						</p>
						<div class="choose-people">
							<ul>
								<li v-for="item in selection" v-if="item!=''">{{item}}</li>
							</ul>
						</div>
					</div>
					<div class="item-wrap">
						<p class="item-title">
							<span class="name">
								<img src="../../assets/img/finds/ic_list_tab@2x.png"/>
								足迹地点
							</span>
							<span class="option" @click="toApp">
								管理地点
								<img src="../../assets/img/common/ic_arrow_enter@2x.png"/>
							</span>
						</p>
						<div class="manage-add">
							<ul>
								<li v-for="item in footprints">{{item.region_name}}</li>
							</ul>
						</div>
					</div>
				</mt-tab-container-item>
				<mt-tab-container-item id="2">
					<div class="trend-list">
						<ul>
							<li>
								<div class="item-time">
									<p class="item-date">今天</p>
								</div>
								<div class="item-content" @click="sendTrend">
									<span class="send-trend"><img src="../../assets/img/finds/ic_btn_add@2x.png" alt="" /></span>
								</div>
							</li>
							<li v-for="item in trendsInfo">
								<div class="item-time">
									<p class="item-date"><span class="day">{{item.update_time|convertTime("DD")}}</span><span class="month">{{item.update_time|convertTime("MM")}}</span></p>
									<p class="item-address">{{item.address}}</p>
								</div>
								<div class="item-content">
									<div class="content-inner">
										<div class="item-img" v-if="item.type!=0">
											<img :src="item.attach[0]"/>
											<div class="video-play" v-if="item.type==2">
												<img src="../../assets/img/trends/dyn_dyn_ic_video.png" alt="" />
											</div>
										</div>
										<div class="item-text">
											<p>{{item.text}}</p>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</mt-tab-container-item>
				<mt-tab-container-item id="3">
					<div class="tree-list">
						<ul>
							<li v-for="item in treeInfo">
								<p class="item-title"><img src="../../assets/img/trends/dyn_tree_ic_anony.png"/>{{item.title}}</p>
								<p class="item-text">{{item.title}}</p>
								<p class="item-related">
									<span class="item-time">发布于{{item.create_time|convertTime("YYYY.MM.DD")}}</span>
									<span class="item-views">{{item.views}}人看过</span>
								</p>
							</li>
						</ul>
					</div>
				</mt-tab-container-item>
			</mt-tab-container>
		</div>
		<mend-sign v-if="showMendSign" :uid="uid" title="修改约会宣言" :text="baseInfo.sig" @closeMend="closeMend"></mend-sign>
		<mend-nickname v-if="showMendNickname" :uid="uid" title="修改昵称" :text="baseInfo.sig" @closeMend="closeMend"></mend-nickname>
	</div>
</template>

<script>
	import MendSign from "./MendSign"
	import MendNickname from "./MendNickname"
	export default {
		name: "my-page-mine",
		components:{
			MendSign,
			MendNickname
		},
		data() {
			return {
				uid: "",
				selected: "1",
				baseInfo:"",
				footprints:"",
				selection:"",
				trendsInfo:"",
				trendPage:1,
				treeInfo:"",
				treePage:1,
				showMendSign:0,
				showMendNickname:0,
			}
		},
		filters:{
			educationFormat(data){
				switch(data){
					case "1":
						return "大专以下";
						break;
					case "2":
						return "大专";
						break;
					case "3":
						return "本科";
						break;
					case "4":
						return "硕士";
						break;
					case "5":
						return "博士";
						break;
					case "6":
						return "海外留学";
						break;
				}
			}
		},
		created() {
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
			this.getBaseInfo();
			
			this.getTrendInfo();
			
			this.getTreeInfo();
		},
		methods:{
			getBaseInfo(){
				this.$axios({
					url:'My/PersonalInfo',
					method:"post",
					data:{
						uid:this.uid
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.baseInfo = res.data.data.info;
						this.footprints = res.data.data.footprints;
						this.selection = res.data.data.selection;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			changeAvatar(e){
				let formData = new FormData();
				let avatar = e.target.files[0];
				formData.append('uid',this.uid);
				formData.append('img',avatar);
				if(formData.get("img")){
					this.$messagebox.confirm('确定修改头像么?').then(action => {
						this.$axios({
							url:"User/UpdateAvatar",
							method:"post",
							data:formData
						}).then(res=>{
							console.log(res);
							if(res.data.code==200){
								this.$toast({message:"修改成功",position: "bottom",duration: 2000});
								this.getBaseInfo();
							}
						})
					});
				}else{
					console.log("2")
				}
				
			},
			getTrendInfo(){
				this.$axios({
					url:'My/PersonalDynamic',
					method:"post",
					data:{
						uid:this.uid,
						page:this.trendPage
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.trendsInfo = res.data.data;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			getTreeInfo(){
				this.$axios({
					url:'My/PersonalTreeHole',
					method:"post",
					data:{
						uid:this.uid,
						page:this.treePage
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.treeInfo = res.data.data;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			closeMend(s){
				if(s==0){
					this.showMendSign = 0;
					this.showMendNickname = 0;
				}else{
					this.showMendSign = 0;
					this.showMendNickname = 0;
					this.getBaseInfo();
				}
			},
			sendTrend(){
				this.$router.push({name:"send-trend"})
			},
			toApp(){
				this.$toast({message:"下载鱼水缘App查看更多足迹地点",position: "bottom",duration: 2000});
			},
			toAppDo(){
				this.$toast({message:"下载鱼水缘App添加更多形象照",position: "bottom",duration: 2000});
			}
		}
	}
</script>

<style scoped>
	.my-page-wrap {
		padding-top: 3rem;
	}
	
	.page-title-bar {
		text-align: center;
		background: #FFFFFF;
		padding: 0.3rem 0;
		position: fixed;
		width: 100%;
		top: 0;
		left: 0;
		z-index: 10;
		border-bottom: 1px solid #f3f3f3;
	}
	
	.page-title-bar .user-name {
		font-size: 0.8rem;
		color: #282828;
		font-weight: bold;
		line-height: 1.2rem;
	}
	
	.page-title-bar .user-info {
		font-size: 0.65rem;
		color: #7b7b7b;
	}
	
	.page-title-bar .back {
		position: absolute;
		top: 0.15rem;
		left: 0rem;
	}
	
	.page-title-bar .back img {
		width: 2.5rem;
	}
	>>>.mint-navbar .mint-tab-item.is-selected{
		border-bottom-color: #8157F7;
	}
	
	.user-intro {
		background: #fff;
		padding: 1.5rem 0 0.5rem;
		text-align: center;
	}
	
	.user-intro .user-img {
		position: relative;
		display: flex;
		justify-content: center;
	}
	
	.user-intro .user-avatar {
		display: inline-block;
		width: 4rem;
		height: 4rem;
		border-radius: 50%;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}
	.user-intro .user-avatar input{
		position: absolute;
		width: 100%;
		height: 100%;
		opacity: 0;
	}
	.user-intro .user-avatar img {
		width: 4rem;
		display: block;
	}
	
	.user-intro .user-img .level {
		position: absolute;
		top: -0.75rem;
		left: calc(50% + 0.8rem);
	}
	
	.user-intro .user-img .level .num {
		font-size: 0.65rem;
		color: #fff;
		position: absolute;
		top: 0.7rem;
		left: 0.5rem;
		transform: rotate(45deg);
	}
	
	.user-intro .user-img .sex {
		position: absolute;
		top: 2.8rem;
		left: calc(50% + 0.8rem);
		background: #fff;
		border-radius: 50%;
	}
	
	.user-intro .user-img .level img {
		width: 1.8rem;
		display: block;
	}
	
	.user-intro .user-img .sex img {
		width: 1.3rem;
		display: block;
	}
	
	.user-intro .user-name {
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.user-intro .user-name img {
		width: 1.8rem;
		margin-left: 0.5rem;
	}
	
	.user-intro .user-info {
		font-size: 0.8rem;
		color: #7b7b7b;
		line-height: 1.5rem;
	}
	
	.user-show ul {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
		margin: 0.3rem 0 0.5rem;
		overflow-x: scroll;
		background: #fff;
	}
	
	.user-show li {
		padding: 0 0.2rem;
		background: #f4f4f4;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 8rem;
		width: 8rem;
		margin:1px 0.5rem 1px 0;
		border-radius: 3px;
	}
	
	.user-show li img {
		max-height: 8rem;
		width: auto;
		display: block;
		max-width: 100%;
	}
	.user-show li:last-of-type img{
		width: 4rem;
		height: 4rem;
		margin: 0 2rem;
	}
	.personal-info .item-title{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem;
		background: #fff;
		margin-top: 4px;
	}
	.personal-info .item-title:active{
		background: #fafafa;
	}
	.personal-info .item-title span{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.personal-info .item-title span.name{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
	}
	.personal-info .item-title span.name img{
		width: 1.2rem;
		margin-right: 0.5rem;
	}
	.personal-info .item-title span.option{
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.personal-info .item-title span.option img{
		width: 1.5rem;
	}
	.personal-info .sign-text{
		font-size: 0.8rem;
		color: #282828;
		line-height: 1.4rem;
		margin: 2px 0;
		padding: 0.8rem;
		background: #fff;
	}
	.personal-info .certi-list{
		padding: 0.8rem;
		background: #fff;
		margin-top: 2px;
	}
	.personal-info .certi-list li{
		display: inline-block;
		width: 23%;
		text-align: center;
		padding: 0.5rem;
		font-size: 0.65rem;
		color: #7b7b7b;
		box-sizing: border-box;
	}
	.personal-info .certi-list li img{
		width: 2rem;
		display: inline-block;
	}
	.personal-info .baseinfo ul{
		padding-left:1.5rem;
		margin-top: 2px;
		background: #fff;
	}
	.personal-info .baseinfo li{
		padding: 0.5rem 0.8rem;
		border-bottom: 1px solid #f3f3f3;
		background: #fff;
	}
	.personal-info .baseinfo li .name{
		width: 5rem;
		display: inline-block;
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.personal-info .baseinfo li .value{
		font-size: 0.8rem;
		color: #282828;
	}
	.personal-info .choose-people,
	.personal-info .manage-add{
		padding: 0.8rem;
		background: #fff;
		margin: 2px 0;
	}
	.personal-info .choose-people li,
	.personal-info .manage-add li{
		display: inline-block;
		margin: 0.3rem;
		background: #FF6161;
		padding: 0.3rem 1rem;
		border-radius: 3px;
		font-size: 0.8rem;
		color: #fff;
		opacity: 0.7;
	}
	.personal-info .choose-people li:nth-child(even){
		background: #01AEF0;
	}
	.personal-info .manage-add li{
		background: #5415F9;
		opacity: 0.5;
	}
	
	.trend-list ul{
		padding-top: 4px;
	}
	.trend-list li{
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		padding: 0.5rem 1rem;
		background: #fff;
		border-bottom: 1px solid #f3f3f3;
	}
	.trend-list li .send-trend img{
		width: 5rem;
		display: block;
	}
	.trend-list li .item-time{
		width: 4rem;
	}
	.trend-list li .item-date{
		font-size: 1.1rem;
		line-height: 1.8rem;
		font-weight: bold;
	}
	.trend-list li .item-date .month{
		padding-left: 0.5rem;
		font-size: 1rem;
		font-weight: 600;
	}
	.trend-list li .item-address{
		font-size: 0.8rem;
		color: #282828;
	}
	.trend-list li .item-content,
	.trend-list li .item-content>div{
		flex: 1;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.trend-list li .content-inner{
		padding: 0.5rem 0.7rem;
		background: #f3f3f3;
	}
	.trend-list li .item-img{
		min-width: 4rem;
		min-height: 4rem;
		max-width: 4rem;
		max-height: 4rem;
		display: block;
		overflow: hidden;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.trend-list li .item-img img{
		width: 4rem;
		display: block;
	}
	.trend-list li .item-img .video-play{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(0,0,0,.3);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.trend-list li .item-img .video-play img{
		width: 2rem;
	}
	.trend-list li .item-text{
		font-size: 0.8rem;
		color: #282828;
		word-break:break-all;
		display:-webkit-box;
		-webkit-line-clamp:3;
		-webkit-box-orient:vertical;
		overflow:hidden;
		padding: 0 0.3rem;
	}
	
	.tree-list ul{
		margin-top: 4px;
	}
	.tree-list li{
		padding: 0.5rem 1rem;
		background: #FFFFFF;
		border-bottom: 1px solid #f3f3f3;
	}
	.tree-list li .item-title{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.tree-list li .item-title img{
		width: 2rem;
		margin-right: 0.5rem;
	}
	.tree-list li .item-text{
		font-size: 0.9rem;
		color: #282828;
		opacity: 0.8;
		word-break:break-all;
		display:-webkit-box;
		-webkit-line-clamp:3;
		-webkit-box-orient:vertical;
		overflow:hidden;
		padding: 0 0.3rem;
		margin: 0.5rem 0;
	}
	.tree-list li .item-related{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	
	.no-content{
		padding: 0;
		text-align: left;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/MyPageMine.vue